import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

const Navbar = ({ setPage }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showSolutionsDropdown, setShowSolutionsDropdown] = useState(false);
  const navigate = useNavigate();

  const handleNavigation = (path, page) => {
    if (setPage) setPage(page);
    setIsOpen(false);
    setShowSolutionsDropdown(false);
    navigate(path);
  };

  return (
    <>
      {/* Main Navbar */}
      <nav className="navbar">
        {/* Logo */}
        <div className="logo" onClick={() => handleNavigation('/', 'home')}>
          <div className="logo-text">
            <img
              className="logo-img"
              src="/images/Blue_Waves_Logo.png"
              alt="Blue Waves Ship Management Logo"
            />
          </div>
        </div>

        {/* Navigation Menu */}
        <ul className={`navbar-menu ${isOpen ? 'open' : ''}`}>
          <li>
            <Link
              to="/"
              className="has-dropdown"
              onClick={() => handleNavigation('/', 'home')}
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              to="/about"
              className="has-dropdown"
              onClick={() => handleNavigation('/about', 'about')}
            >
              Company
            </Link>
          </li>
          <li
            className="navbar-dropdown"
            onMouseEnter={() => setShowSolutionsDropdown(true)}
            onMouseLeave={() => setShowSolutionsDropdown(false)}
          >
            <Link
              to="/services"
              className="has-dropdown"
              onClick={() => handleNavigation('/services', 'services')}
            >
              Solutions ▼
            </Link>
            {showSolutionsDropdown && (
              <ul className="dropdown-menu">
                <li onClick={() => handleNavigation('/services/ship-management', 'Ship Management')}>
                  Ship Management
                </li>
                <li onClick={() => handleNavigation('/services/ship-design-naval-architecture', 'Ship Design & Naval Architecture')}>
                  Ship Design & Naval Architecture
                </li>
                <li onClick={() => handleNavigation('/services/tug-barge-operations', 'Tug & Barge')}>
                  Tug & Barge Operations
                </li>
                <li onClick={() => handleNavigation('/services/drydock', 'Drydock Services')}>
                  Ship Drydock Services
                </li>
                <li onClick={() => handleNavigation('/services/voyage', 'Voyage Repairs & Afloat Maintenance')}>
                  Voyage Repairs & Afloat Maintenance
                </li>
                <li onClick={() => handleNavigation('/services/crew', 'Crew Manning & Supply')}>
                  Crew Manning & Supply
                </li>
                <li onClick={() => handleNavigation('/services/marine', 'Marine Technical')}>
                  Marine Technical Services
                </li>
              </ul>
            )}
          </li>

          <li>
            <Link
              to="/projects"
              className="has-dropdown"
              onClick={() => handleNavigation('/projects', 'projects')}
            >
              Sustainability
            </Link>
          </li>
          <li>
            <Link
              to="/career"
              onClick={() => handleNavigation('/career', 'career')}
            >
              Careers
            </Link>
          </li>
          <li>
            <Link
              to="/news"
              onClick={() => handleNavigation('/news', 'news')}
            >
              News
            </Link>
          </li>
          <li>
            <Link
              to="/contact"
              className="connect-button"
              onClick={() => handleNavigation('/contact', 'contact')}
            >
              Connect
            </Link>
          </li>
        </ul>

        {/* Top Utility Bar */}
        <div className="topbar">
          <div className="topbar-right">
            <select className="language-selector" aria-label="Language Selector">
              <option>EN</option>
              <option>FR</option>
              <option>ES</option>
            </select>
            <div className="social-icons">
              <a href="https://facebook.com/share/18ojPfJ7D1" target="_blank" rel="noopener noreferrer" aria-label="Facebook">f</a>
              <a href="https://linkedin.com/in/blue-waves-38898536b" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">in</a>
              <a href="https://tiktok.com/@blue.waves.ship.m?is_from_webapp-1&sender_device=pc" target="_blank" rel="noopener noreferrer" aria-label="TikTok">▶</a>
            </div>
          </div>
        </div>

        {/* Mobile Toggle */}
        <button className="navbar-toggle" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle navigation">
          ☰
        </button>
      </nav>
    </>
  );
};

export default Navbar;